import React from 'react';
import { FacetList, useHawksearch, PageContentItem } from 'react-hawksearch';

const VerticalZones = {
	leftBottom: 'LeftBottom',
	leftTop: 'LeftTop',
	featuredLeftBottom: 'FeaturedLeftBottom',
	featuredLeftTop: 'FeaturedLeftTop',
};

function PreviewFacetRail() {
	const {
		store: { searchResults },
	} = useHawksearch();
	let matchedMerchandisingItems: PageContentItem[] = searchResults
		? searchResults.Merchandising.Items.filter(i => Object.values(VerticalZones).includes(i.Zone))
		: [];

	matchedMerchandisingItems = matchedMerchandisingItems.concat(
		searchResults
			? searchResults.FeaturedItems.Items.filter(i => Object.values(VerticalZones).includes(i.Zone))
			: []
	);
	if (searchResults && !searchResults.Results.length && matchedMerchandisingItems.length === 0) {
		return null;
	}
	return (
		<div className="hawk-facet-rail col-xs-12 col-sm-3 filter-sidebar">
			<div className="narrow-results-wrapper accordion-container">
				<span
					className="filter-search-title accordion-trigger"
					aria-expanded="false"
					aria-controls="accord-content-0"
					role="button"
					tabIndex={0}
					data-init="initialized"
				>
					Filter by:
				</span>
				<FacetList />
			</div>
		</div>
	);
}

export default PreviewFacetRail;
